export const validateRoom = (room, roomIndex, rentalType, bookingType) => {
    const errors = [];

    const roomPrefix = `Room ${room.roomNumber || roomIndex + 1}`;
  
    if (!room.roomNumber || room.roomNumber.toString().trim() === '') {
      errors.push({
        error: `${roomPrefix}: Room number is required`,
        errorType: "room",
        field: "roomNumber",
        roomIndex
      });
    }

    if (!room.roomName || room.roomName.trim() === '') {
      errors.push({
        error: `${roomPrefix}: Room name is required`,
        errorType: "room",
        field: "roomName",
        roomIndex
      });
    }

    if (typeof room.numberOfBathroom !== 'number' || room.numberOfBathroom < 0) {
      errors.push({
        error: `${roomPrefix}: Valid number of bathrooms is required`,
        errorType: "room",
        field: "numberOfBathroom",
        roomIndex
      });
    }

    if (rentalType === "Crashpad") {
      if (!room.roomType) {
        errors.push({
          error: `${roomPrefix}: Room type is required`,
          errorType: "room",
          field: "roomType",
          roomIndex
        });
      }

      if (!room.genderType) {
        errors.push({
          error: `${roomPrefix}: Gender type is required`,
          errorType: "room",
          field: "genderType",
          roomIndex
        });
      }

      if (!room.crewType) {
        errors.push({
          error: `${roomPrefix}: Crew type is required`,
          errorType: "room",
          field: "crewType",
          roomIndex
        });
      }

      if (room.roomType === "Private" && room.numberOfBeds > 1) {
        errors.push({
          error: `${roomPrefix}: Private room can have maximum 1 bed`,
          errorType: "room",
          field: "numberOfBeds",
          roomIndex
        });
      }

      if (room.roomType === "Shared" && room.numberOfBeds > 50) {
        errors.push({
          error: `${roomPrefix}: Shared room can have maximum 50 beds`,
          errorType: "room",
          field: "numberOfBeds",
          roomIndex
        });
      }
    }

    if (!room.beds || room.beds.length === 0) {
      errors.push({
        error: `${roomPrefix}: At least 1 bed is required`,
        errorType: "bed",
        field: "beds",
        roomIndex
      });
    } else {
      if (room.beds.length !== room.numberOfBeds) {
        errors.push({
          error: `${roomPrefix}: Number of beds (${room.numberOfBeds}) must equal added beds (${room.beds.length})`,
          errorType: "bed",
          field: "numberOfBeds",
          roomIndex
        });
      }

      const bedNumbers = new Set();
      
      room.beds.forEach((bed, bedIndex) => {
        const bedPrefix = `${roomPrefix}, Bed ${bedIndex + 1}`;

        if (rentalType === "Crashpad") {
          if (!bed.bedNumber || bed.bedNumber.toString().trim() === '') {
            errors.push({
              error: `${bedPrefix}: Bed number is required`,
              errorType: "bed",
              field: "bedNumber",
              roomIndex,
              bedIndex
            });
          } else {
            const trimmedBedNumber = bed.bedNumber.toString().trim();
            
            if (bedNumbers.has(trimmedBedNumber)) {
              errors.push({
                error: `${roomPrefix}: Bed number "${trimmedBedNumber}" must be unique within the room`,
                errorType: "bed",
                field: "bedNumber",
                roomIndex,
                bedIndex
              });
            } else {
              bedNumbers.add(trimmedBedNumber);
            }
          }

          const needsNightPrice = bookingType === "Hot bed" || bookingType === "Flexible";
          const needsMonthPrice = bookingType === "Cold bed" || bookingType === "Flexible";

          if (needsNightPrice && (!bed.perNightPrice || bed.perNightPrice < 1)) {
            errors.push({
              error: `${bedPrefix}: Per night price is required and must be at least 1`,
              errorType: "bed",
              field: "perNightPrice",
              roomIndex,
              bedIndex
            });
          }

          if (needsMonthPrice && (!bed.perMonthPrice || bed.perMonthPrice < 1)) {
            errors.push({
              error: `${bedPrefix}: Per month price is required and must be at least 1`,
              errorType: "bed",
              field: "perMonthPrice",
              roomIndex,
              bedIndex
            });
          }
        }

        if (!bed.bedType) {
          errors.push({
            error: `${bedPrefix}: Bed type is required`,
            errorType: "bed",
            field: "bedType",
            roomIndex,
            bedIndex
          });
        }

        const validBedTypes = ["King", "Queen", "Twin", "Couch", "Top bunk", "Bottom bunk", "Other"];
        if (bed.bedType && !validBedTypes.includes(bed.bedType)) {
          errors.push({
            error: `${bedPrefix}: Invalid bed type "${bed.bedType}"`,
            errorType: "bed",
            field: "bedType",
            roomIndex,
            bedIndex
          });
        }
      });
    }

    return {
        isValid: errors.length === 0,
        errors: errors,
    };
}

export const validateSleepingArrangements = (formData = {}) => {
    const errors = [];
    const { rentalType, bookingType } = formData;
    const roomList = formData.sleepingArrangements
  
    if (!roomList || roomList.length === 0) {
      return {
        isValid: false,
        errors: [{ 
          error: "At least 1 room is required", 
          errorType: "room",
          field: "roomList"
        }]
      };
    }
  
    roomList.forEach((room, roomIndex) => {
        const roomErrors = validateRoom(room, roomIndex, rentalType, bookingType).errors
        if(roomErrors.length > 0) {
            errors.push(...roomErrors)
        }
        
    });
  
    const roomNumbers = new Set();
    roomList.forEach((room, index) => {
      if (room.roomNumber) {
        const trimmedRoomNumber = room.roomNumber.toString().trim();
        if (roomNumbers.has(trimmedRoomNumber)) {
          errors.push({
            error: `Room number "${trimmedRoomNumber}" must be unique`,
            errorType: "room",
            field: "roomNumber",
            roomIndex: index
          });
        } else {
          roomNumbers.add(trimmedRoomNumber);
        }
      }
    });
  
    return {
      isValid: errors.length === 0,
      errors: errors,
    };
  };